<template>
  <div class="home-div">
    <SideBar />
    <div class="mid">
      <div class="comments-container mbl-no-hover">
      <h1 class="font-color-1">留言板</h1>
      <div class="comment-form">
        <textarea class="bgc font-color-1 input-style" v-model="newComment" placeholder="来都来了，不防停留片刻，说点什么？" rows="3"></textarea>
        <input class="bgc font-color-1 input-style" v-model="newName" placeholder="昵称必填" style="width: 200px;"/>
        <input class="bgc font-color-1 input-style" v-model="email" placeholder="邮箱（选填）" style="width: 200px"/>
        <button @click="submitComment" class="submit-btn">发表留言</button>
      </div>
      
      <div class="comments-list">
        <div v-for="comment in comments" :key="comment.id" 
             :class="['comment-item', { 'unprocessed': comment.qsStatus === 0 }]">
          <div class="comment-header font-color-1">
            <img src="@/assets/live2d-photo.png" class="user-avatar" alt="用户头像">
            <span class="username">{{ comment.userName }}</span>
            <span class="comment-time">{{ displayDate(comment.createdTime) }}</span>
            <button @click="showReplyBox(comment)" class="reply-btn font-color-1">回复</button>
          </div>
          <div class="comment-content font-color-4">{{ comment.qsInfo }}</div>
          
          <!-- 显示子评论数量和加载状态 -->
          <div class="replies-info" v-if="comment.replyCount > 0">
            <span class="reply-count font-color-1" @click="loadReplies(comment)">
              共 {{ comment.replyCount }} 条回复，点击查看
              <span v-if="comment.loadingReplies" class="loading-text font-color-1">加载中...</span>
            </span>
          </div>
          
          <!-- 一级回复 -->
          <div v-if="comment.replies && comment.replies.length > 0" class="replies-container">
            <div v-for="reply in comment.replies" 
                 :key="reply.id" class="reply-item">
              <div class="reply-header">
                <img src="@/assets/live2d-photo.png" class="user-avatar" alt="用户头像">
                <span class="username font-color-1">{{ reply.userName }}</span>
                <span class="reply-time font-color-4">{{ displayDate(reply.createdTime) }}</span>
                <button @click="showReplyBox(comment, reply)" class="reply-btn font-color-1">回复</button>
              </div>
              <div class="reply-content font-color-4">
                {{ reply.qsInfo }}
              </div>
            </div>
            
            <!-- 二级评论加载更多 -->
            <div v-if="comment.hasMoreReplies" class="load-more-replies">
              <button @click="loadMoreReplies(comment)" class="load-more-btn">
                {{ comment.loadingMore ? '加载中...' : '加载更多回复' }}
              </button>
            </div>
          </div>
          
          <!-- 回复框 -->
          <div v-if="activeReplyBox === comment.id" class="reply-box">
            <textarea  class="bgc font-color-1 input-style" v-model="replyContent" :placeholder="`@${comment.userName} `" ref="replyTextarea"></textarea>
            <input class="bgc font-color-1 input-style" v-model="newName" placeholder="昵称必填" style="width: 200px;"/>
            <input class="bgc font-color-1 input-style" v-model="email" placeholder="邮箱（选填）" style="width: 200px"/>
            <div class="reply-actions">
              <button @click="submitReply(comment)" class="submit-btn font-color-1">回复</button>
              <button @click="cancelReply" class="cancel-btn">取消</button>
            </div>
          </div>
        </div>
      </div>
      
      <!-- 滚动加载提示 -->
      <div v-if="loading" class="loading-more">
        加载中...
      </div>
      <div v-if="hasMore" class="load-more-hint">
        继续滚动加载更多顶级留言
      </div>
      <div v-if="!hasMore && comments.length > 0" class="no-more">
        没有更多顶级留言了
      </div>
    </div>
    </div>
    <BottomTip />
  </div>
</template>

<script>
import SideBar from '@/components/menu/SideBar.vue';
import BottomTip from '@/components/menu/BottomTip.vue';
import { Message } from 'element-ui';

import { saveCommentsData, getQsList, getReplyList } from '@/api/comments';

export default {
  name: 'Comments',
  components: {
    SideBar,
    BottomTip
  },
  data() {
    return {
      newComment: '',
      newName: '',
      id: -1,
      replyContent: '',
      replyUserName: '',
      comments: [],
      email: '',
      activeReplyBox: null,
      currentReplyTo: null,
      currentPage: 1,
      pageSize: 5,
      totalPages: 0,
      loading: false,
      hasMore: true,
      scrollLoading: false
    }
  },
  async mounted() {
    await this.getQsListInfo();
    this.setupScrollListener(); 
  },
  methods: {
        displayDate(date) {
      return date.split(' ')[0];
    },
    setupScrollListener() {
      window.addEventListener('scroll', this.handleScroll);
    },
    removeScrollListener() {
      window.removeEventListener('scroll', this.handleScroll);
    },
    async handleScroll() {
      if (this.loading || !this.hasMore || this.scrollLoading) return;
      
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      const windowHeight = window.innerHeight;
      const scrollHeight = document.documentElement.scrollHeight;
      
      // 距离底部100px时开始加载
      if (scrollTop + windowHeight >= scrollHeight - 100) {
        this.scrollLoading = true;
        await this.loadMoreComments();
        this.scrollLoading = false;
      }
    },
    async loadMoreComments() {
      if (this.currentPage >= this.totalPages) {
        this.hasMore = false;
        return;
      }
      
      this.loading = true;
      this.currentPage++;
      
      try {
        const resp = await getQsList({
          id: this.id, 
          lifeId: 0, 
          pageNo: this.currentPage, 
          pageSize: this.pageSize 
        });
        
        if (resp.code === 200) {
          const newComments = resp.data.data || [];
          // 为每个新评论初始化回复相关属性
          newComments.forEach(comment => {
            comment.replies = [];
            comment.replyPage = 1;
            comment.hasMoreReplies = false;
            comment.loadingReplies = false;
            comment.loadingMore = false;
          });
          this.comments = [...this.comments, ...newComments];
          
          if (this.currentPage >= resp.data.totalPage) {
            this.hasMore = false;
          }
        } else {
          Message.error(resp.msg || '加载更多失败');
          this.currentPage--;
        }
      } catch (error) {
        Message.error('网络错误，请稍后重试');
        this.currentPage--;
      } finally {
        this.loading = false;
      }
    },
    async getQsListInfo() {
      this.loading = true;
      try {
        const resp = await getQsList({
          id: this.id, 
          lifeId: 0, 
          pageNo: 1, 
          pageSize: this.pageSize 
        });
        if (resp.code === 200) {
          this.currentPage = 1;
          this.comments = resp.data.data || [];
          this.totalPages = resp.data.totalPage || 1;
          
          // 初始化每个评论的回复相关属性
          this.comments.forEach(comment => {
            comment.replies = [];
            comment.replyPage = 1;
            comment.hasMoreReplies = comment.replyCount > 0;
            comment.loadingReplies = false;
            comment.loadingMore = false;
          });
          
          this.hasMore = this.currentPage < this.totalPages;
        } else {
          Message.error(resp.msg || '获取留言列表失败，请稍后重试');
        }
      } catch (error) {
        Message.error('网络错误，请稍后重试');
      } finally {
        this.loading = false;
      }
    },
    async loadReplies(comment) {
      if (comment.loadingReplies || comment.replies.length > 0) return;
      
      comment.loadingReplies = true;
      try {
        const resp = await getQsList({
          lifeId: 0,
          id: comment.id,
          pageNo: 1,
          pageSize: this.pageSize // 每次加载5条回复
        });
        
        if (resp.code === 200) {
          comment.replies = resp.data.data || [];
          comment.replyPage = 1;
          // 判断是否还有更多回复
          comment.hasMoreReplies = comment.replies.length >= this.currentSize && 
                                 comment.replies.length < comment.replyCount;
        } else {
          Message.error(resp.msg || '加载回复失败');
        }
      } catch (error) {
        Message.error('网络错误，请稍后重试');
      } finally {
        comment.loadingReplies = false;
      }
    },
    async loadMoreReplies(comment) {
      if (comment.loadingMore) return;
      
      comment.loadingMore = true;
      try {
        const nextPage = comment.replyPage + 1;
        const resp = await getQsList({
          lifeId: 0,
          id: comment.id,
          pageNo: nextPage,
          pageSize: this.pageSize
        });
        
        if (resp.code === 200) {
          const newReplies = resp.data.data || [];
          comment.replies = [...comment.replies, ...newReplies];
          comment.replyPage = nextPage;
          // 更新是否还有更多回复的状态
          comment.hasMoreReplies = comment.replies.length < comment.replyCount;
        } else {
          Message.error(resp.msg || '加载更多回复失败');
        }
      } catch (error) {
        Message.error('网络错误，请稍后重试');
      } finally {
        comment.loadingMore = false;
      }
    },
    async submitComment() {
      if(this.newComment.trim() === ''){
        Message.error('内容必填哦！');
        return;
      }
      if(this.newName.trim() === ''){
        Message.error('昵称必填哦！');
        return;
      }
      
      const newComment = {
        parentId: null,
        lifeId: 0, 
        email: this.email,
        userName: this.newName,
        qsInfo: this.newComment
      };
      
      saveCommentsData(newComment).then(resp => {
        if(resp.code === 200){
          Message.success('留言成功，感谢您的反馈！');
          this.newComment = '';
          // 重新加载第一页数据
          this.currentPage = 0;
          this.hasMore = true;
          this.getQsListInfo();
        } else {
          Message.error(resp.msg || '留言失败，请稍后重试');
        }
      }).catch(() => {
        Message.error('网络错误，请稍后重试');
      });
    },
    showReplyBox(comment, reply = null) {
      this.activeReplyBox = comment.id;
      this.currentReplyTo = reply ? reply.userName : comment.userName;
      this.replyContent = `@${this.currentReplyTo} `;
      
this.$nextTick(() => {
    // 增加延迟确保 DOM 完全渲染
    setTimeout(() => {
      if (this.$refs.replyTextarea && typeof this.$refs.replyTextarea.focus === 'function') {
        this.$refs.replyTextarea.focus();
      } else {
        console.warn('回复文本框未找到:', this.$refs.replyTextarea);
      }
    }, 100);
  });
    },
    submitReply(comment) {
      if(this.replyContent.trim() === ''){
        Message.error('留言内容必填哦！');
        return;
      }
      if(this.newName.trim() === ''){
        Message.error('昵称必填哦！');
        return;
      }
      
      const newReply = {
        lifeId: 0,
        email: this.email,
        parentId: comment.id,
        userName: this.newName,
        qsInfo: this.replyContent
      };
      
      saveCommentsData(newReply).then(resp => {
        if(resp.code === 200){
          Message.success('回复成功！');
          this.replyContent = '';
          this.replyUserName = '';
          this.activeReplyBox = null;
          this.currentReplyTo = null;
          
          // 更新回复数量
          comment.replyCount = (comment.replyCount || 0) + 1;
          comment.hasMoreReplies = true;
          
          // 如果已经加载了回复列表，重新加载第一页
          if (comment.replies.length > 0) {
            this.loadReplies(comment);
          }
        } else {
          Message.error(resp.msg || '回复失败，请稍后重试');
        }
      }).catch(() => {
        Message.error('网络错误，请稍后重试');
      });
    },
    cancelReply() {
      this.activeReplyBox = null;
      this.currentReplyTo = null;
      this.replyContent = '';
    }
  }
};
</script>

<style scoped>
@media (max-width: 768px) {
  .comments-container {
    width: 90% !important;
  }
}

.home-div {
 width: 100%;
  min-height: 100%;
  margin: 0;
  padding-top: 60px;
  overflow: hidden;
}
.mid{
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  justify-content: space-between; /* 关键属性 */
  align-items: center;
    overflow-y: auto;
}

.input-style::placeholder {
  color: var(--font-color-4);
  opacity: 1;
}

.comments-container {
  width: 60%;
  border-radius: 10px;
  height: auto;
  padding: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 1;
}

.comments-container h1 {
  text-align: center;
  margin-bottom: 20px;
  font-size: 24px;
}

.comment-form {
  margin-bottom: 30px;
}

.bgc{
  background-color: rgba(255, 255, 255, 0.2);
}

.comment-form textarea {
  width: 100%;
  padding: 12px 0 12px 0;
  border: 1px solid #ddd;
  border-radius: 6px;
  resize: vertical;
  font-size: 14px;
  margin-bottom: 10px;
}

.comment-form input {
  width: 100px;
  padding: 7px;
  border: 1px solid #ddd;
  border-radius: 6px;
  resize: vertical;
  font-size: 14px;
  margin-bottom: 10px;
  margin-right: 10px;
}

.comment-item {
  border-bottom: 1px solid #eee;
  padding: 15px 0;
  margin-bottom: 15px;
}

.comment-item.unprocessed {
  /* background-color: #fff9e6; */
  border-radius: 6px;
  padding: 15px;
  /* border-left: 4px solid #ffcc00; */
}

.comment-header {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 10px;
  object-fit: cover;
}

.username {
  /* font-weight: bold; */
  margin-right: 10px;
}

.comment-time, .reply-time {
  font-size: 12px;
  margin-right: auto;
}

.reply-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 13px;
  padding: 2px 8px;
  border-radius: 4px;
}

.reply-btn:hover {
  background-color: #1890ff;
}

.comment-content {
  margin-left: 50px;
  line-height: 1.6;
}

/* 回复信息样式 */
.replies-info {
  margin-left: 50px;
  margin-top: 10px;
}

.reply-count {
  cursor: pointer;
  font-size: 13px;
  padding: 4px 8px;
  border-radius: 4px;
  display: flex;
  justify-content: flex-end;
}

.loading-text {
  font-style: italic;
}

.replies-container {
  margin-left: 50px;
  margin-top: 15px;
  border-left: 2px solid #eee;
  padding-left: 15px;
}

.reply-item {
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px dashed #eee;
}

.reply-item:last-child {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}

.reply-header {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}

.reply-content {
  margin-left: 50px;
  line-height: 1.5;
}

/* 加载更多回复按钮 */
.load-more-replies {
  text-align: center;
  margin-top: 10px;
}

.load-more-btn {
  background: none;
  border: 1px solid #e9e8e8;
  color: var(--font-color-4);
  padding: 4px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
}

.load-more-btn:hover {
  border-color: #1890ff;
  color: #1890ff;
}

.reply-to {
  color: #1890ff;
  font-weight: bold;
}

.reply-box {
  margin-top: 15px;
  margin-left: 50px;
}

.reply-box textarea {
  width: 100%;
  padding: 12px 0 12px 0;
  border: 1px solid #ddd;
  border-radius: 6px;
  resize: vertical;
  font-size: 14px;
  margin-bottom: 10px;
}

.reply-box input {
  width: 100px;
  padding: 7px;
  border: 1px solid #ddd;
  border-radius: 6px;
  resize: vertical;
  font-size: 14px;
  margin-bottom: 10px;
  margin-right: 10px;
}

.reply-actions {
  display: flex;
  justify-content: flex-end;
}

.submit-btn, .cancel-btn {
  padding: 6px 15px;
  border-radius: 4px;
  font-size: 13px;
  cursor: pointer;
  margin-right: 10px;
}

.submit-btn {
  background-color: #1890ff;
  color: white;
  border: none;
}

.submit-btn:hover {
  background-color: #40a9ff;
}

.cancel-btn {
  background: none;
  border: 1px solid #d9d9d9;
  color: #FFFFFF;
}

.cancel-btn:hover {
  border-color: #1890ff;
  color: #1890ff;
}

/* 滚动加载样式 */
.loading-more {
  text-align: center;
  padding: 20px;
  color: #999;
}

.load-more-hint {
  text-align: center;
  padding: 15px;
  color: var(--font-color-4);
  font-size: 14px;
}

.no-more {
  text-align: center;
  padding: 20px;
  color: #999;
  font-size: 14px;
}
</style>